import { Component, createRef, Fragment } from 'react'
import _ from 'lodash'
import cx from 'classnames'
import moment from 'moment'
import UiStateContainer from '@vzmi/ec-react-ui-state-container'
import { connect } from 'react-redux'
import { formValueSelector } from 'redux-form'
import InfiniteScroll from 'react-infinite-scroll-component'
import actions from 'redux-form/lib/actions'
import arrayMove from 'array-move'
import { Toast, Button, ProposalBlock, MenuSelect, Tip, FormLoader } from '@vzmi/shp_shared_compo'
import { HistoryUtil } from '@vzmi/component_ec_nodejs_util/dist/lib'
import { PRODUCT_SHIP_TYPE, PROPOSAL_TYPE } from '@vzmi/shp_shared_compo/constants/proposal'
import { getFeatureToggle } from '@vzmi/component_ec_nodejs_util/dist/lib/FeatureToggleUtil'
import { scrollElementToCenter, delay } from '../../../../../lib/renderUtil'
import safeAwait from '../../../../../lib/safeAwait'
import errorHelper, { httpHandler } from '../../../../../lib/errorHelper'
import { getUpdateListingModelValidateResult } from '../../../../lib/listingUtil'
import { UPDATE_LISTING_FORM_KEY } from '../../../../constants/proposalTypes'
import { HyperLink } from '../../../Common/Form'
import LoadingSpinner, { SIZE } from '../../../Common/LoadingSpinner/LoadingSpinner'
import InvalidListingModal from '../../Common/InvalidListingModal'
import { COMMA, idsOnlyParser } from '@vzmi/component_ec_nodejs_util/dist/lib/parserUtil'
import {
  loadLocal,
  saveIntoLocal,
  removeLocal
} from '../../../../lib/localStorageHelper'
import { getAttrLevelFromListing } from '../helpers/getters'
import styles from './index.css'
import ImportForm, {
  CONFIG as IMPORT_FORM_CONFIG,
  FIELD as IMPROT_FORM_FIELD
} from './ImportForm'
import ListingInfo from '../ListingInfo'
import ModelTable, {
  COLUMN as TABLE_COLUMN,
  FORM_SECTION_NAME as TABLE_FORM_SECTION_NAME
} from './ModelTable'
import {
  getAttrMap,
  getTableRowsFromListing,
  getTableRowsWithExpectedAttrValues,
  getTableRowFromProduct,
  getReduxFormField,
  getProductsOverLimitMsg,
  convertGroupedRowsToModels,
  getConvertedTableInfo,
  checkIsListingChanged,
  getModifiedTableRows,
  getProductWithSpec,
  getProductIdParentMap,
  getSpecSortListFromRows,
  getSortedSpecModelTableInfo,
  getFakeProductId,
  getTableField,
  getTableRowsWithoutDuplicated,
  getListingParamsFromForm,
  getProductIdsFromListing,
  getListingWithAttrsFromProducts
} from './helpers'
import {
  PRODUCT_KEY,
  PRODUCTS_MAX_SIZE,
  ERROR_CODE,
  TABLE_TIP_KEY,
  REMOVE_MODE_TABLE_TIP_KEY,
  LISTING_CHANGE_STATUS,
  PRODUCT_MODAL_TYPE,
  LAYER_CHANGED_DEFAULT_SKU
} from './constants'
import ImportRuleModal from './Modal/ImportRule'
import SpecSortModal, {
  CONFIG as SPEC_SORT_FORM_CONFIG
} from './Modal/SpecSort'
import DeleteProductModal from './Modal/Product/Delete'
import VisibleProductModal from './Modal/Product/Visible'
import NewProductModal from './Modal/NewProduct'
import SortConfirmModal from './Modal/SortConfirm'
import ListingChangedModal from './Modal/ListingChanged'
import BatchRemoveModal from './Modal/BatchRemove'
import EditModeTableTip from './TableTip/EditModeTableTip'
import RemoveModeTableTip from './TableTip/RemoveModeTableTip'
import {
  TABLE_TYPE as EXTRA_MODEL_TABLE_TYPE,
  PAYLOAD_DIFF_TYPE,
  FORM_SECTION as EXTRA_MODEL_FORM_SECTION
} from './ExtraModelTable/helper'
import ComplimentariesTable from './ExtraModelTable/Complimentaries'
import SelectComplimentariesTable from './ExtraModelTable/SelectComplimentaries'
import AdditionalPurchasesTable from './ExtraModelTable/AdditionalPurchases'
import ExtraModelReadOnlyTable from './ExtraModelTable/ReadOnly'
import { getIsTwoLayerListing } from '../../UpdateListingInfo/helper'

const UPDATE_LISTING_MODEL_STATE_KEY = 'UPDATE_LISTING_MODEL_STATE_KEY'
const ROW_SIZE = PRODUCTS_MAX_SIZE.ONE_LAYER.ATTR
const EXTRA_MODEL_TITLE = {
  [EXTRA_MODEL_TABLE_TYPE.COMPLIMENTARIES]: '贈品買就送',
  [EXTRA_MODEL_TABLE_TYPE.SELECT_COMPLIMENTARIES]: '贈品任選',
  [EXTRA_MODEL_TABLE_TYPE.ADDITIONAL_PURCHASES]: '加價購'
}
const EXTRA_MODEL_TABLE = {
  [EXTRA_MODEL_TABLE_TYPE.COMPLIMENTARIES]: ComplimentariesTable,
  [EXTRA_MODEL_TABLE_TYPE.SELECT_COMPLIMENTARIES]: SelectComplimentariesTable,
  [EXTRA_MODEL_TABLE_TYPE.ADDITIONAL_PURCHASES]: AdditionalPurchasesTable
}
const EXTRA_MODEL_TABLE_TYPES = [
  EXTRA_MODEL_TABLE_TYPE.COMPLIMENTARIES,
  EXTRA_MODEL_TABLE_TYPE.SELECT_COMPLIMENTARIES,
  EXTRA_MODEL_TABLE_TYPE.ADDITIONAL_PURCHASES
]
// 2023/09/27 台灣時間早上 10 點開放賣場屬性調整贈品、加價購修改
// 此時間之後的提案才顯示贈品、加價購表格
const getIsProposalShowExtraModals = createTs => moment(createTs).isAfter(moment('2023-09-27T02:00:00Z'))

class ListingModel extends Component {
  constructor (props) {
    super(props)
    this.state = {
      importRuleModalVisible: false,
      specSortModalVisible: false,
      deleteProductModalVisible: false,
      visibleProductModalVisible: false,
      newProductModalVisible: false,
      sortConfirmModalVisible: false,
      invalidListingModalVisible: false,
      listingChangedModalVisible: false,
      batchRemoveModalVisible: false,
      isNoLayerAttr: false,
      isTwoLayerAttr: false,
      isLayerAttrChanged: false,
      isDataLoadFromStorage: false,
      isAllowedLoadmore: false,
      isBatchRemoveMode: false,
      isDuplicatedProductExist: false,
      isExpress24Hr: false,
      isProductsLoading: false,
      invalidListingValidation: {},
      proposalFormListing: {},
      productIdParentMap: {},
      specSortList: [],
      groupBySpecTableRows: {},
      sortedTableRows: [],
      removedTableRows: [],
      visibleRows: [],
      defaultRowMap: {},
      addedTableRowMap: {},
      targetProducts: [],
      specDetailMapBySpec: null,
      attributesOptionsMapByName: null,
      attrSelectorOptions: [],
      attrSelectorValue: [],
      nameChangedFromUserByProductId: {}
    }
    this.modelTable = createRef()
    this.specSortModal = createRef()
    this.batchRemoveModal = createRef()
    this.columnsProps = {
      onSpecSortModalOpen: this.onSpecSortModalOpen,
      onProductModalOpen: this.onProductModalOpen,
      onChangeProductVisible: this.onChangeProductVisible
    }
    this.afterModalConfirm = null
    this.afterModalCancel = null
  }

  async componentDidMount () {
    const { setRef, targetListingId } = this.props
    // 讓外層 component(UpdateListingForm, UpdateListing) 可以操作這個 component 的 function
    setRef(this)

    // 逾時觸發儲存 state 下次導回來時可以回到原先修改的狀態
    window.addEventListener('beforeunload', this.beforeLeavePage)
    const prevState = loadLocal(UPDATE_LISTING_MODEL_STATE_KEY)
    const isTargetListingState = (
      // okta redirect 回來時直接到 compose 頁，會直接從 storage 取得資料不會有 listingId，
      // 所以如果 undefined 代表說是 redirect 回來的頁面可以直接從 storage 取得資料
      _.isUndefined(targetListingId) ||
      _.isEqual(`${targetListingId}`, `${_.get(prevState, 'proposalFormListing.id')}`)
    )
    if (isTargetListingState) {
      this.setState({ ...prevState, isDataLoadFromStorage: true })
    }
    removeLocal(UPDATE_LISTING_MODEL_STATE_KEY)
  }

  componentWillUnmount () {
    window.removeEventListener('beforeunload', this.beforeLeavePage)
  }

  getSortableTableRef = ref => {
    const sortableTableRef = _.get(ref, 'current.sortableTable.current', {})
    return sortableTableRef
  }

  // 根據賣場的子站找出可以用的商品屬性，新增商品時用於選取屬性
  loadNewProductSpecOptions = async () => {
    const {
      actions = {},
      form = {}
    } = this.props
    const { fetchStruDataAttrClusterOptions } = actions
    const struDataAttrClusterId = _.get(form, 'initiallyFetchedListing.productStructuredDataList[0].struDataAttrClusterId')
    const params = {
      id: struDataAttrClusterId,
      proposalType: PROPOSAL_TYPE.NEW_LISTING
    }
    const [error, payload] = await safeAwait(
      fetchStruDataAttrClusterOptions(params).then(httpHandler)
    )
    const errorMessage = errorHelper.parseErrorMessage(error)
    if (errorMessage) {
      Toast.error(errorMessage)
      return
    }

    const attributes = _.flow(
      () => _.find(payload, { value: struDataAttrClusterId }),
      struDataAttrClusterOption => _.get(struDataAttrClusterOption, 'attrCluster.attributes', [])
    )()
    const attributesOptionsMap = _.reduce(attributes, (collect, attribute) => {
      const { constraints, name, values } = attribute
      const options = _.map(values, value => ({ label: value, value }))

      collect[name] = { constraints, options }
      return collect
    }, {})
    const attrSelectorOptions = _.map(attributes, attribute => {
      const attr = _.get(attribute, 'name', '')
      return { label: attr, value: attr }
    })
    // 請求如果沒有成功 specDetailMapBySpec 就會維持在 null，modal 會用來判斷是否維持在 loading 狀態
    this.setState({
      specDetailMapBySpec: attributesOptionsMap,
      attributesOptionsMapByName: attributesOptionsMap,
      attrSelectorOptions
    })
  }

  createListingModelProposals = async (params) => {
    const { createListingModelProposals } = this.props.actions
    const [error, payload] = await safeAwait(
      createListingModelProposals(params).then(httpHandler)
    )
    const errorMessage = errorHelper.parseErrorMessage(error)
    if (errorMessage) {
      return [errorMessage]
    }

    return [undefined, payload]
  }

  fetchProductsFromListing = async (listing) => {
    const models = _.get(listing, 'models', [])
    const isTwoLayerListing = getIsTwoLayerListing(models)
    const firstAttributeName = _.get(models, '0.spec.name')
    const secondAttributeName = _.get(models, '0.items[0].spec.name')
    const attributeNames = isTwoLayerListing
      ? [firstAttributeName, secondAttributeName]
      : [firstAttributeName]
    const { fetchProducts } = this.props.actions
    const productIdsChunkList = _.chunk(getProductIdsFromListing(listing), 50)
    const [error, products] = await safeAwait(
      Promise.all(
        _.isEmpty(productIdsChunkList)
          ? []
          : productIdsChunkList.map(productIds => {
            const id = productIds.join(COMMA)
            if (_.isEmpty(id)) {
              return {}
            }
            return fetchProducts({ id, limit: 50 }).then(httpHandler)
          })
      ).then(payloads => {
        const totalProducts = _.reduce(payloads, (collect, item) => {
          const newProducts = _.get(item, 'products', [])
          collect = [...collect, ...newProducts]
          return collect
        }, [])
        return totalProducts
      })
    )
    const errorMessage = errorHelper.parseErrorMessage(error)
    if (errorMessage) {
      return [errorMessage]
    }

    const productsWithModelsAttributesOnly = _.map(products, product => {
      const structuredData = _.get(product, 'structuredData', {})
      const modelsAttributes = _.flow(
        () => _.get(structuredData, 'attributes', []),
        // 確認排序需按照第一層、第二層屬性
        attributes => {
          const attributeMapByName = _.keyBy(attributes, 'name')
          const newModelsAttributes = attributeNames.map(attributeName => {
            return _.get(
              attributeMapByName,
              attributeName,
              // 顯示名稱預設值找不到時會要求使用者填入，但是規格需要先幫他帶入否則給 api 時會缺少規格欄位
              { name: attributeName, values: [] }
            )
          })
          return newModelsAttributes
        }
      )()
      return {
        ...product,
        structuredData: {
          ...structuredData,
          attributes: modelsAttributes
        }
      }
    })
    return [undefined, productsWithModelsAttributesOnly]
  }

  showImportResult = async (payload) => {
    const { dispatch } = this.props
    const {
      allowedSkuList = [],
      errors = []
    } = payload
    const isProductListExist = !_.isEmpty(allowedSkuList)
    const isErrorExist = !_.isEmpty(errors)
    let errorResult

    if (isProductListExist && isErrorExist) {
      errorResult = '部分商品不符合條件，請重新確認條件規定，僅匯入符合的商品於下方區塊'
    } else if (!isProductListExist && isErrorExist) {
      const isNoProductFound = !_.some(errors, error => error.code !== ERROR_CODE.INVALID_PRODUCT_ID)
      errorResult = isNoProductFound
        ? (
          <p>
            商品不存在，請檢查商品編號或
            <HyperLink
              target='_blank'
              href='/proposal/newProduct/compose'
            >
              新增商品提案
            </HyperLink>
          </p>
        )
        : (
          <p>
            商品條件不符合，請重新確認
            <HyperLink onClick={this.onImportRuleModalOpen}>
              條件規定
            </HyperLink>
          </p>
        )
    }
    if (!_.isEmpty(errorResult)) {
      const [form, field] = [IMPORT_FORM_CONFIG.form, IMPROT_FORM_FIELD.PRODUCT_IDS]
      // redux form 送出有部分匯入成功會清除該筆商品編號觸發表單的 onChange 重新驗證輸入值，
      // 因為實際上錯誤不是格式錯誤，這樣錯誤訊息就會被清除掉，
      // 所以需要加上一個非同步讓 setError 在下一個執行緒再執行，確保不會被清除
      await delay(0)
      dispatch(
        actions.updateSyncErrors(form, { [field]: errorResult })
      )
      return
    }

    Toast.success('商品匯入成功')
  }

  removeImportedProductFromTextarea = (inputProductIds, payload) => {
    const importedProductIds = _.get(payload, 'allowedSkuList', [])
    const importFailProductIds = _.join(
      _.difference(inputProductIds, importedProductIds),
      COMMA
    )
    // 將匯入成功的商品從輸入框移除
    this.props.dispatch(
      actions.change(IMPORT_FORM_CONFIG.form, IMPROT_FORM_FIELD.PRODUCT_IDS, importFailProductIds)
    )
  }

  onImportProducts = async (formValues) => {
    this.props.setIsLoading(true)
    const {
      form: {
        listing: {
          listingSpecName,
          listingItemSpecName
        } = {}
      } = {}
    } = this.props
    const {
      groupBySpecTableRows,
      specSortList,
      isTwoLayerAttr,
      visibleRows,
      sortedTableRows,
      defaultRowMap
    } = this.state
    const { productIds } = formValues
    const listingParams = this.getListingParams()
    // 匯入匡輸入的全部商品編號
    const totalProductIds = idsOnlyParser(productIds)
    // 扣掉賣場預設的商品編號
    const importProductIds = _.filter(totalProductIds, id => !(id in defaultRowMap))
    // 賣場預設商品編號
    const importProductIdsFromListing = _.filter(totalProductIds, id => (id in defaultRowMap))
    // 從表格中刪除的賣場商品直接從一開始算好的表格列拿回來
    const importTableRowsFromListing = _.map(importProductIdsFromListing, id => _.get(defaultRowMap, id))
    let importProducts = []
    let importTableRows = []
    if (!_.isEmpty(totalProductIds)) {
      // 有匯入非賣場預設的商品編號
      if (!_.isEmpty(importProductIds)) {
        const params = {
          ...listingParams,
          skuCandidates: importProductIds,
          dryrun: true
        }
        const [errorMessage, payload] = await this.createListingModelProposals(params)
        if (errorMessage) {
          Toast.error(errorMessage)
          this.props.setIsLoading(false)
          return
        }

        const defaultNames = {
          [PRODUCT_KEY.SPEC_NAME]: listingSpecName,
          [PRODUCT_KEY.ITEM_SPEC_NAME]: listingItemSpecName
        }
        this.showImportResult(payload)
        // 從 api 回應和賣場預設的商品編號中找出有成功找到對應的商品編號
        const importedpayload = {
          ...payload,
          allowedSkuList: _.concat(
            _.get(payload, 'allowedSkuList', []),
            importProductIdsFromListing
          )
        }
        this.removeImportedProductFromTextarea(totalProductIds, importedpayload)
        // 匯入 request 成功後將賣場資料拆成表格用資料格式
        const sortedProductIds = _.get(payload, 'allowedSkuList', [])
        importProducts = _.flow(
          payload => _.get(payload, 'products', []),
          products => _.keyBy(products, 'sku'),
          productsGroupById => _.map(sortedProductIds, id => {
            const product = _.get(productsGroupById, id, {})
            return getProductWithSpec(product, defaultNames, isTwoLayerAttr)
          })
        )(payload)
        importTableRows = _.reduce(importProducts, (collect, product, index) => {
          collect = _.concat(
            collect,
            {
              ...getTableRowFromProduct(product, defaultNames, isTwoLayerAttr),
              index: _.size(sortedTableRows) + index
            }
          )
          return collect
        }, [])
      } else {
        // 匯入的商品編號都是賣場預設就有刪除後又加入的，加個 delay 讓操作上感覺效果比較好
        await delay(300)
        const payload = { allowedSkuList: importProductIdsFromListing }
        this.removeImportedProductFromTextarea(importProductIdsFromListing, payload)
        this.showImportResult(payload)
      }
    }
    importTableRows = _.concat(importTableRowsFromListing, importTableRows)

    const defaultTableInfo = {
      groupedRows: groupBySpecTableRows,
      specSortList
    }
    const {
      sortedTableRows: newSortedTableRows,
      specSortList: newSpecSortList,
      groupedRowsWithIndex
    } = getConvertedTableInfo(defaultTableInfo, importTableRows, isTwoLayerAttr)
    const currentRowSize = _.size(visibleRows) + _.size(importTableRows)
    const newVisibleRows = _.slice(newSortedTableRows, 0, currentRowSize)
    // 匯入後可能影響既有表格列排序，因此需要重洗一次表格列
    this.updateReduxFormRows(newVisibleRows, true)
    let errorMsg
    this.setState(
      () => ({
        sortedTableRows: newSortedTableRows,
        groupBySpecTableRows: groupedRowsWithIndex,
        specSortList: newSpecSortList,
        visibleRows: newVisibleRows
      }),
      () => this.getOverLimitError()
    )
    // 手動更新提案表單的商品屬性
    const currentModels = _.get(this.props, 'form.models', [])
    this.props.change('models', _.concat(currentModels, importProducts))
    this.showErrorIfProductsOverLimit(errorMsg)
    this.props.setIsLoading(false)
  }

  getOverLimitError = () => {
    const {
      specSortList,
      groupBySpecTableRows,
      isTwoLayerAttr
    } = this.state
    const overLimitError = getProductsOverLimitMsg(
      specSortList,
      groupBySpecTableRows,
      isTwoLayerAttr
    )
    return overLimitError
  }

  getListingParams = () => {
    const { form } = this.props
    const params = getListingParamsFromForm(form)
    return params
  }

  // 更新提案表單裡的欄位，這樣新增的表格列才會帶入預設值
  updateModalTableForm = (importTableRows) => {
    const { form } = this.props
    const { isTwoLayerAttr } = this.state
    let updateFieldsMap = _.reduce(importTableRows, (fieldsMap, row) => {
      const attrMap = getAttrMap(isTwoLayerAttr)
      const productId = _.get(row, attrMap.productId)
      const attributes = _.get(row, attrMap.attributes)
      _.set(fieldsMap, getTableField(productId, TABLE_COLUMN.ATTRIBUTES, row), attributes)
      if (_.isUndefined(productId)) {
        return fieldsMap
      }

      const specs = [
        _.get(row, PRODUCT_KEY.SPEC_SELECTED_VALUE),
        _.get(row, PRODUCT_KEY.ITEM_SPEC_SELECTED_VALUE)
      ]
      for (let specIndex = 0; specIndex < specs.length; specIndex++) {
        const spec = specs[specIndex]
        if (_.isUndefined(spec)) {
          break
        }

        // 0 === layer1Attr
        // 1 === layer2Attr
        // 商品為雙層屬性時第一層為選單，接受的資料格式是 [value]
        const [column, fieldValue] = specIndex === 0
          ? [TABLE_COLUMN.SPEC_SELECTED_VALUE, isTwoLayerAttr ? [spec] : spec]
          : [TABLE_COLUMN.ITEM_SPEC_SELECTED_VALUE, spec]
        _.set(fieldsMap, getTableField(productId, column, row), fieldValue)
      }
      return fieldsMap
    }, {})
    updateFieldsMap = {
      ..._.get(form, TABLE_FORM_SECTION_NAME, {}),
      ...updateFieldsMap
    }
    // 一次更新表格中的單層雙層屬性欄位
    this.props.change(TABLE_FORM_SECTION_NAME, updateFieldsMap)
  }

  onAttrChange = (event, record, column) => {
    const {
      specSortList: prevSpecSortList,
      isTwoLayerAttr,
      sortedTableRows,
      visibleRows,
      groupBySpecTableRows
    } = this.state
    const clonedTableRows = _.cloneDeep(sortedTableRows)
    const { index: rowIndex } = record
    const fieldValue = (
      (isTwoLayerAttr && column === TABLE_COLUMN.SPEC_SELECTED_VALUE) ||
      column.startsWith(TABLE_COLUMN.ATTRIBUTES)
    )
      // menu select 時 onChange 回傳為 [value]
      ? _.get(event, '0')
      : _.get(event, 'target.value')
    let prevFieldValue
    switch (column) {
      case TABLE_COLUMN.SPEC_SELECTED_VALUE: {
        prevFieldValue = _.get(clonedTableRows, `${rowIndex}.${PRODUCT_KEY.SPEC_SELECTED_VALUE}`)
        break
      }
      case TABLE_COLUMN.ITEM_SPEC_SELECTED_VALUE: {
        prevFieldValue = _.get(clonedTableRows, `${rowIndex}.${PRODUCT_KEY.ITEM_SPEC_SELECTED_VALUE}`)
        break
      }
      default:
        break
    }
    this.executeOrWaitForConfirm(
      () => {
        // 雙層屬性賣場 且 修改第一列
        const isTwoLayerListingFirstRowChanged = (isTwoLayerAttr && rowIndex === 0)
        // 修改第一層屬性 且 修改值與原本不同
        const isSpecSortChanged = (
          column === TABLE_COLUMN.SPEC_SELECTED_VALUE &&
          fieldValue !== prevFieldValue
        )
        return (isTwoLayerListingFirstRowChanged && isSpecSortChanged)
      },
      async () => {
        const isEmptyValue = _.isEmpty(fieldValue)
        if (prevFieldValue === fieldValue || isEmptyValue) {
          return
        }
        let isUpdatePosition = false

        const attrMap = getAttrMap(isTwoLayerAttr)
        const { [attrMap.productId]: productId } = record
        let changeSpecSelectedValueColumn = null
        const originProductName = _.get(clonedTableRows, `${rowIndex}.${attrMap.productName}`, '')
        switch (column) {
          case TABLE_COLUMN.SPEC_SELECTED_VALUE: {
            changeSpecSelectedValueColumn = PRODUCT_KEY.SPEC_SELECTED_VALUE
            if (isTwoLayerAttr) {
              isUpdatePosition = true
              // 標記為改變群組(第一層屬性)的表格列，highlight 整列
              _.set(clonedTableRows, `${rowIndex}.isUpdatedCollection`, true)
              _.set(clonedTableRows, `${rowIndex}.collection`, fieldValue)
              if (!(fieldValue in groupBySpecTableRows)) {
                // 雙層屬性賣場修改第一層既有屬性名稱(A)成一個新的名稱(B)會將群組換一到一個新的第一層分類
                // 所以需要一個假的 id 識別這個分類(B)
                _.set(clonedTableRows, `${rowIndex}.${PRODUCT_KEY.ID}`, getFakeProductId(fieldValue))
              } else {
                // 雙層屬性賣場修改第一層既有屬性名稱(A)成另一個既有的名稱(C)會將群組切換到該既有第一層底下(C)
                const newProductId = _.get(groupBySpecTableRows, `${fieldValue}[0].${PRODUCT_KEY.ID}`)
                _.set(clonedTableRows, `${rowIndex}.${PRODUCT_KEY.ID}`, newProductId)
              }
            }
            _.set(clonedTableRows, `${rowIndex}.${PRODUCT_KEY.SPEC_SELECTED_VALUE}`, fieldValue)
            break
          }
          case TABLE_COLUMN.ITEM_SPEC_SELECTED_VALUE: {
            changeSpecSelectedValueColumn = PRODUCT_KEY.ITEM_SPEC_SELECTED_VALUE
            _.set(clonedTableRows, `${rowIndex}.${PRODUCT_KEY.ITEM_SPEC_SELECTED_VALUE}`, fieldValue)
            break
          }
          case `${TABLE_COLUMN.ATTRIBUTES}[0]`:
          case `${TABLE_COLUMN.ATTRIBUTES}[1]`: {
            const updateAttributeIndex = column.endsWith('[0]') ? 0 : 1
            const updateAttributeField = `${rowIndex}.${PRODUCT_KEY.ATTRIBUTES}[${updateAttributeIndex}].values[0]`
            _.set(clonedTableRows, updateAttributeField, fieldValue)
            break
          }
          case TABLE_COLUMN.NAME: {
            this.setState({
              nameChangedFromUserByProductId: {
                ...this.state.nameChangedFromUserByProductId,
                [productId]: record
              }
            })
            _.set(clonedTableRows, `${rowIndex}.${attrMap.productName}`, fieldValue)
            break
          }
          default:
            break
        }
        // 判斷商品名稱是否有被變更過
        const isProductChangedByUser = (productId in this.state.nameChangedFromUserByProductId)
        // 判斷是否允許連動商品名稱變更後綴
        const isAllowUpdateProductName = (
          // 賣場屬性名稱有變更且時
          changeSpecSelectedValueColumn &&
          // 使用者沒有手動修改過商品名稱
          !isProductChangedByUser &&
          this.props.attrsFeatureToggle
        )
        if (isAllowUpdateProductName) {
          const isFormattedProductName = originProductName.includes('-')
          const originSpecSelectedValue = _.get(record, changeSpecSelectedValueColumn)
          // 如果預設商品名稱就格式就已經不是 xxx-attr 或 xxx-attr-attr 先把商品名稱加上後綴 -
          const convertedProductName = isFormattedProductName ? originProductName : `${originProductName}-`
          const convertedOriginValue = isFormattedProductName ? originSpecSelectedValue : '-'
          const convertedNewValue = isFormattedProductName ? fieldValue : `-${fieldValue}`
          const newProductName = _.replace(convertedProductName, convertedOriginValue, convertedNewValue)
          _.set(clonedTableRows, `${rowIndex}.${attrMap.productName}`, newProductName)
          const productNameField = getReduxFormField(productId, TABLE_COLUMN.NAME, record)
          this.props.change(productNameField, newProductName)
        }
        // 需要自動調整表格列時會把修改的表格列直接放到最後一筆
        // 再透過分群排序整個表格(這樣修改過的表格列就會移至該分群的最後一筆)
        const newTableRows = isUpdatePosition
          ? arrayMove(clonedTableRows, rowIndex, _.size(clonedTableRows) + 1)
          : clonedTableRows
        const defaultTableInfo = {
          specSortList: isTwoLayerAttr ? prevSpecSortList : []
        }
        const {
          sortedTableRows: newSortedTableRows,
          specSortList: newSpecSortList,
          groupedRowsWithIndex: newGroupBySpecTableRows
        } = getConvertedTableInfo(defaultTableInfo, newTableRows, isTwoLayerAttr)
        const newVisibleRows = _.slice(newSortedTableRows, 0, _.size(visibleRows))
        let errorMsg
        await new Promise(resolve => {
          this.setState(
            () => ({
              sortedTableRows: newSortedTableRows,
              groupBySpecTableRows: newGroupBySpecTableRows,
              specSortList: newSpecSortList,
              visibleRows: newVisibleRows
            }),
            () => {
              errorMsg = this.getOverLimitError()
              resolve()
            }
          )
        })
        if (!isUpdatePosition) {
          return
        }

        // 有更新位置代表表格列順序異動，所以需要重洗表格列
        this.updateReduxFormRows(newVisibleRows, false)
        const isOverLimit = !_.isEmpty(errorMsg)
        await this.scrollAndHighlightRow(record, isOverLimit)
      },
      () => {
        const { executeCancelAction } = this.getSortableTableRef(this.modelTable)
        const productId = _.get(record, PRODUCT_KEY.ITEM_ID)
        const targetField = getReduxFormField(productId, column, record)
        // 雙層屬性第一層的選單值為陣列
        this.props.change(targetField, [prevFieldValue])
        executeCancelAction && executeCancelAction()
      }
    )
  }

  scrollAndHighlightRow = async (currentRow, isOverLimit) => {
    const {
      sortedTableRows,
      isTwoLayerAttr,
      visibleRows
    } = this.state
    const itemProductId = _.get(currentRow, PRODUCT_KEY.ITEM_ID)
    const newSortedTableRows = _.map(sortedTableRows, row => ({
      ...row,
      isUpdatedCollection: false
    }))
    const newVisibleRows = _.slice(newSortedTableRows, 0, _.size(visibleRows))
    const {
      groupedRowsWithIndex
    } = getConvertedTableInfo({}, newSortedTableRows, isTwoLayerAttr)
    if (!isOverLimit) {
      await delay(100)
      const targetIndex = _.findIndex(
        newSortedTableRows,
        // 用第一二層的商品名稱加上商品編號找到新的表格列裡對應的位置
        _.pick(currentRow, [
          isTwoLayerAttr ? PRODUCT_KEY.ITEM_ID : PRODUCT_KEY.ID
        ])
      )
      const targetSelector = `#${TABLE_COLUMN.DRAG}${itemProductId}_${targetIndex}`
      const targetRow = document.querySelector(targetSelector)
      // 讓雙層屬性修改第一層屬性改變位置時滾動至畫面中間
      scrollElementToCenter(targetRow)
      // 等 1.5s 後清除 highlight 的表格列
      await delay(1500)
    }
    return new Promise(resolve => {
      this.setState(
        () => ({
          sortedTableRows: newSortedTableRows,
          groupBySpecTableRows: groupedRowsWithIndex,
          visibleRows: newVisibleRows
        }),
        resolve
      )
    })
  }

  setListingModels = async (modifiedListing) => {
    const { readOnly, initialForm } = this.props
    const defaultListing = modifiedListing || _.get(this.props, 'form', {})
    const { specDetailMapBySpec } = this.state
    this.setState({ isProductsLoading: true })
    const [errorMessage, products] = readOnly
      ? [null, []]
      : await this.fetchProductsFromListing(defaultListing)
    if (errorMessage) {
      Toast.error(errorMessage)
      this.props.toggleDisableSubmitBtn(true)
      this.setState({ isProductsLoading: false })
      return
    }
    const listing = readOnly
      ? defaultListing
      : getListingWithAttrsFromProducts(defaultListing, products)
    const attrLevel = getAttrLevelFromListing(listing)
    const isNoLayerAttr = (attrLevel === 0)
    const isTwoLayerAttr = (attrLevel === 2)
    // 有傳入 modifiedListing 代表賣場屬性的層數改變，ex: 無屬性變單層屬性
    const isLayerAttrChanged = !_.isEmpty(modifiedListing)
    const attrMap = getAttrMap(isTwoLayerAttr)
    const originTableRows = _.flow(
      () => getTableRowsFromListing(listing),
      tableRowsFromListing => {
        // 無屬性賣場、有傳入 modifiedListing、或是唯讀代表非 init value 不操作預設值
        if (isNoLayerAttr || modifiedListing || readOnly) {
          return tableRowsFromListing
        }

        return getTableRowsWithExpectedAttrValues(tableRowsFromListing, specDetailMapBySpec)
      }
    )()
    const tableRowsWithoutDuplicated = getTableRowsWithoutDuplicated(originTableRows)
    const filteredTableRows = _.filter(tableRowsWithoutDuplicated, row => !(
      row[PRODUCT_KEY.ID] === LAYER_CHANGED_DEFAULT_SKU ||
      row[PRODUCT_KEY.ITEM_ID] === LAYER_CHANGED_DEFAULT_SKU
    ))
    const isDuplicatedProductExist = !_.isEqual(originTableRows, tableRowsWithoutDuplicated)
    const specSortList = getSpecSortListFromRows(tableRowsWithoutDuplicated)
    const {
      sortedTableRows: currentSortedTableRows,
      specSortList: newSpecSortList,
      groupedRowsWithIndex
    } = getConvertedTableInfo({ specSortList }, filteredTableRows, isTwoLayerAttr)
    // 無屬性賣場預設不顯示任何屬性可以調整
    const sortedTableRows = isNoLayerAttr ? [] : currentSortedTableRows
    const productIdParentMap = getProductIdParentMap(sortedTableRows)
    const {
      [PRODUCT_KEY.SPEC_NAME]: listingSpecName,
      [PRODUCT_KEY.ITEM_SPEC_NAME]: listingItemSpecName
    } = _.flow(
      () => _.get(tableRowsWithoutDuplicated, '0', {}),
      firstRow => _.pick(firstRow, [PRODUCT_KEY.SPEC_NAME, PRODUCT_KEY.ITEM_SPEC_NAME])
    )()
    const visibleRows = _.slice(sortedTableRows, 0, ROW_SIZE)
    // 過濾掉重複的商品寫回 get listing 時預設商品
    const filteredModels = convertGroupedRowsToModels(newSpecSortList, groupedRowsWithIndex, isTwoLayerAttr)
    this.props.change('listing.listingSpecName', listingSpecName)
    this.props.change('listing.listingItemSpecName', listingItemSpecName)
    this.props.change('models', filteredModels)
    if (readOnly && this.checkIsNoLayerListingBefore()) {
      this.setState({ attrSelectorValue: [listingSpecName] })
    }

    const shipTypeId = _.get(initialForm, 'skuDetail.shipType.id')
    const isExpress24Hr = shipTypeId === PRODUCT_SHIP_TYPE.EXPRESS_24HR
    this.setState(
      () => ({
        isNoLayerAttr,
        isTwoLayerAttr,
        isLayerAttrChanged,
        isDuplicatedProductExist,
        isExpress24Hr,
        specSortList: newSpecSortList,
        sortedTableRows,
        productIdParentMap,
        groupBySpecTableRows: groupedRowsWithIndex,
        defaultRowMap: _.keyBy(sortedTableRows, attrMap.productId),
        visibleRows,
        isProductsLoading: false
      }),
      () => this.updateModifiedTableRows()
    )
    // 首次進入表單載入後首次寫入 redux form 表格列
    this.updateReduxFormRows(visibleRows, true)
  }

  onImportRuleModalOpen = () => {
    this.setState({ importRuleModalVisible: true })
  }

  onImportRuleModalCancel = () => {
    this.setState({ importRuleModalVisible: false })
  }

  onBatchRemoveModalOpen = () => {
    this.setState({ batchRemoveModalVisible: true })
  }

  onBatchRemoveModalCancel = () => {
    this.setState({ batchRemoveModalVisible: false })
  }

  onSpecSortModalOpen = () => {
    this.setState({
      specSortModalVisible: true
    })
  }

  onSpecSortModalCancel = () => {
    const { resetDataSource } = this.getSortableTableRef(this.specSortModal)
    this.setState(
      () => ({ specSortModalVisible: false }),
      async () => {
        await delay(300)
        resetDataSource && resetDataSource()
      }
    )
  }

  onSpecSortModalOk = () => {
    const { readOnly } = this.props
    if (readOnly) {
      this.onSpecSortModalCancel()
      return
    }

    const updatedSpecRowMapById = _.get(
      this.specSortModal.current,
      `props.reduxFormState.values.${SPEC_SORT_FORM_CONFIG.section}`,
      {}
    )
    const sortedSpecRows = _.get(
      this.getSortableTableRef(this.specSortModal),
      'state.dataSource',
      []
    )
    const {
      sortedSpecDataSource,
      updatedSpecMapById,
      updatedAttributesMapById
    } = getSortedSpecModelTableInfo(
      updatedSpecRowMapById,
      sortedSpecRows
    )
    const specKey = PRODUCT_KEY.SPEC_SELECTED_VALUE
    this.executeOrWaitForConfirm(
      () => {
        const { specSortList } = this.state
        return _.get(specSortList, '0') !== _.get(sortedSpecDataSource, `0.${specKey}`)
      },
      () => {
        const { attrsFeatureToggle } = this.props
        const {
          sortedTableRows,
          isTwoLayerAttr,
          nameChangedFromUserByProductId
        } = this.state
        // 從 specSortModal 的表格取得買場屬性調整後第一層的名稱排序
        // 重新排序並修改名稱後有可能出現重複第一層名稱，因此需要用 uniq 合併
        const newSpecSortList = _.uniq(
          _.map(sortedSpecDataSource, specKey)
        )
        // 取得修改過的第一層商品屬性表格列對應表
        const rowMapBySpecName = _.keyBy(sortedSpecDataSource, specKey)
        // 按照第一層屬性寫入 model table 要修改的欄位
        const convertedTableRows = _.map(sortedTableRows, row => {
          const productId = _.get(row, PRODUCT_KEY.ID)
          const updatedSpec = _.get(updatedSpecMapById, productId)
          // 如果再調整第一層順序時屬性名稱有修改就需要改成用新的屬性名稱才能找到對應表格列
          const currentSpecSelectedValue = updatedSpec
            ? _.get(updatedSpec, 'newSpecSelectedValue')
            : _.get(row, PRODUCT_KEY.SPEC_SELECTED_VALUE)
          const updateColumns = _.pick(
            _.get(rowMapBySpecName, currentSpecSelectedValue, {}),
            [
              PRODUCT_KEY.SPEC_VISIBLE,
              PRODUCT_KEY.SPEC_SELECTED_VALUE,
              // 雙層屬性賣場相同第一層商品如果其中一個商品修改第一層項目顯示名稱會從既有第一層獨立成另一個 models
              // 這時候再把修改過的項目顯示名稱改回既有的因為要併回既有 models 需要把第一層 sku(productId) 寫回去
              PRODUCT_KEY.ID
            ]
          )
          let newRow = { ...row, ...updateColumns }
          const itemProductId = _.get(newRow, PRODUCT_KEY.ITEM_ID)
          if (!(itemProductId in nameChangedFromUserByProductId) && attrsFeatureToggle) {
            const originProductName = _.get(newRow, PRODUCT_KEY.ITEM_NAME, '')
            const originSpecSelectedValue = _.get(row, PRODUCT_KEY.SPEC_SELECTED_VALUE, '')
            const newProductName = _.replace(originProductName, originSpecSelectedValue, currentSpecSelectedValue)
            newRow = {
              ...newRow,
              [PRODUCT_KEY.ITEM_NAME]: newProductName,
              // 並回 models 後為了讓拖曳區塊分群可以列入新併入的需要把分群判斷的欄位複寫掉
              collection: currentSpecSelectedValue
            }
          }
          // 因為只有第一層的屬性項目要被批次變更，所以只有在取得新的屬性項目前才把完整 attributes 併入 newRow
          // 否則第二層的屬性項目也會被覆蓋
          const newRowWithSpecAttributes = {
            ...newRow,
            ..._.pick(
              _.get(rowMapBySpecName, currentSpecSelectedValue, {}),
              [PRODUCT_KEY.ATTRIBUTES]
            )
          }
          const newProductId = _.get(newRow, PRODUCT_KEY.ID)
          const updatedAttributes = _.get(updatedAttributesMapById, newProductId)
          const newFirstAttributeValue = _.get(
            _.isUndefined(updatedAttributes)
              ? _.get(newRowWithSpecAttributes, PRODUCT_KEY.ATTRIBUTES, [])
              : _.get(updatedAttributes, 'newAttributes', []),
            '0.values[0]'
          )
          if (!_.isUndefined(newFirstAttributeValue)) {
            _.set(newRow, `${PRODUCT_KEY.ATTRIBUTES}[0].values[0]`, newFirstAttributeValue)
          }
          return newRow
        })
        const {
          sortedTableRows: newSortedTableRows,
          groupedRowsWithIndex
        } = getConvertedTableInfo(
          { specSortList: newSpecSortList },
          convertedTableRows,
          isTwoLayerAttr
        )
        const newVisibleRows = _.slice(newSortedTableRows, 0, ROW_SIZE)
        this.setState({
          specSortList: newSpecSortList,
          sortedTableRows: newSortedTableRows,
          groupBySpecTableRows: groupedRowsWithIndex,
          visibleRows: newVisibleRows
        })
        // 因為 spec 變更會影響全部表格列排序，因此重洗一次表格列
        this.updateReduxFormRows(newVisibleRows, false)
        this.onSpecSortModalCancel()
      }
    )
  }

  getProductModelVisiblekey = type => {
    let productModalVisibleKey
    switch (type) {
      case PRODUCT_MODAL_TYPE.DELETE:
        productModalVisibleKey = 'deleteProductModalVisible'
        break
      case PRODUCT_MODAL_TYPE.VISIBLE:
        productModalVisibleKey = 'visibleProductModalVisible'
        break
      case PRODUCT_MODAL_TYPE.NEW:
        productModalVisibleKey = 'newProductModalVisible'
        break
      default:
        break
    }
    return productModalVisibleKey
  }

  onProductModalOpen = (rows, type) => {
    const key = this.getProductModelVisiblekey(type)
    this.setState({
      targetProducts: rows,
      [key]: true
    })
  }

  onProductModalCancel = (type) => {
    const key = this.getProductModelVisiblekey(type)
    this.setState(
      () => ({ [key]: false }),
      // 等 modal 關閉才能清除資料否則會在關閉前看到商品資料消失
      async () => {
        await delay(300)
        this.setState({ targetProduct: [] })
      }
    )
  }

  onChangeProductVisible = (rowData) => {
    const {
      specSortList,
      targetProducts,
      sortedTableRows,
      isTwoLayerAttr,
      visibleRows
    } = this.state

    // spec modal 裡修改後暫存在 spec mdoal 中，在按下確認前不會修改 proposal form 的資料
    const targetProduct = _.get(targetProducts, '0')
    if (_.get(targetProduct, 'inModal')) {
      this.specSortModal.current.onChangeProductVisible(targetProduct)
      return
    }

    // 修改
    const attrMap = getAttrMap(isTwoLayerAttr)
    const productVisibleKey = attrMap.specVisible
    // 從隱藏切換回顯示狀態時不會開啟 modal 儲存 targetProduct，
    // 所以直接取點擊的 rowData 找出對應表格列
    const productId = _.get(rowData || targetProduct, attrMap.productId)
    const convertedRows = _.map(sortedTableRows, row => {
      if (_.get(row, attrMap.productId) === productId) {
        return { ...row, [productVisibleKey]: !_.get(row, productVisibleKey) }
      }
      return row
    })
    const {
      sortedTableRows: newSortedTableRows,
      groupedRowsWithIndex
    } = getConvertedTableInfo({ specSortList }, convertedRows, isTwoLayerAttr)
    const newVisibleRows = _.slice(newSortedTableRows, 0, _.size(visibleRows))
    this.setState({
      sortedTableRows: newSortedTableRows,
      visibleRows: newVisibleRows,
      groupBySpecTableRows: groupedRowsWithIndex
    })
  }

  onVisibleProductModalCancel = () => this.onProductModalCancel(PRODUCT_MODAL_TYPE.VISIBLE)

  onVisibleProductModalOk = async () => {
    const { targetProducts } = this.state
    if (_.isEmpty(targetProducts)) {
      this.onVisibleProductModalCancel()
      return
    }

    this.onChangeProductVisible()
    this.onVisibleProductModalCancel()
    // prevent redux form submit multiple times
    await delay(10)
    return Promise.resolve()
  }

  onDeleteProductModalCancel = () => this.onProductModalCancel(PRODUCT_MODAL_TYPE.DELETE)

  onDeleteProductModalOk = async () => {
    const { form, dispatch } = this.props
    const listing = _.get(form, 'listing')
    const models = _.get(form, 'models', [])
    const {
      targetProducts,
      sortedTableRows,
      isTwoLayerAttr,
      visibleRows
    } = this.state
    if (_.isEmpty(targetProducts)) {
      this.onDeleteProductModalCancel()
      return
    }

    const attrMap = getAttrMap(isTwoLayerAttr)
    const targetProductMapById = _.keyBy(targetProducts, product => {
      return `${_.get(product, attrMap.productId)}_${product.index}`
    })
    const filteredTableRows = _.filter(sortedTableRows, (row, index) => {
      const removedRow = _.get(targetProductMapById, `${_.get(row, attrMap.productId)}_${index}`)
      // 只保留沒有被刪除的表格列
      return _.isEmpty(removedRow)
    })
    const specSortList = getSpecSortListFromRows(filteredTableRows)
    const {
      sortedTableRows: newSortedTableRows,
      specSortList: newSpecSortList,
      groupedRowsWithIndex
    } = getConvertedTableInfo({ specSortList }, filteredTableRows, isTwoLayerAttr)
    const newVisibleRows = _.slice(newSortedTableRows, 0, _.size(visibleRows))
    await new Promise(resolve => {
      this.setState(
        () => ({
          sortedTableRows: newSortedTableRows,
          groupBySpecTableRows: groupedRowsWithIndex,
          specSortList: newSpecSortList,
          visibleRows: newVisibleRows
        }),
        resolve
      )
    })
    const productIdMap = _.keyBy(targetProducts, PRODUCT_KEY.ID)
    const productItemIdMap = _.keyBy(targetProducts, PRODUCT_KEY.ITEM_ID)
    const newModels = isTwoLayerAttr
      // 雙層屬性有調整時需要更新 redux form 確保資料一致
      ? _.reduce(models, (updatedModels, model) => {
        if (!(model.sku in productIdMap)) {
          return [...updatedModels, model]
        }

        const newModelItems = _.flow(
          () => _.get(model, 'items', []),
          // 清掉被刪掉的第二層屬性
          modelItems => _.filter(modelItems, modelItem => !(modelItem.sku in productItemIdMap))
        )()
        // 如果整個第一層屬性底下的第二層屬性都是空的，直接把第一層屬性移掉
        if (!_.isEmpty(newModelItems)) {
          return [...updatedModels, { ...model, items: newModelItems }]
        }

        return updatedModels
      }, [])
      // 單層屬性賣場直接把第一層屬性移掉
      : _.filter(models, model => !(model.sku in productIdMap))
    // 因為有商品被刪除可能影響整體排序，所以表格列重洗一次
    this.updateReduxFormRows(newVisibleRows, false)
    // 因為有變更，所以更新賣場屬性
    dispatch(
      actions.change(UPDATE_LISTING_FORM_KEY, 'models', newModels)
    )
    this.onDeleteProductModalCancel()
    // 批次刪除手動輸入商品編號的視窗，如果後面跳出的確認視窗確認了要一起關掉
    this.batchRemoveModal.current.onCancel()
    // 離開批次移除模式
    this.toggleBatchRemoveMode(false)
    // 判斷移除商品後賣場是否還有重複的 sku
    const validation = getUpdateListingModelValidateResult(listing)
    if (!validation.isValid) {
      return
    }

    const errorMsg = getProductsOverLimitMsg(
      newSpecSortList,
      groupedRowsWithIndex,
      isTwoLayerAttr
    )
    this.showErrorIfProductsOverLimit(errorMsg)
  }

  onNewProductModalOpen = (rows) => this.onProductModalOpen(rows, PRODUCT_MODAL_TYPE.NEW)

  onNewProductModalCancel = () => this.onProductModalCancel(PRODUCT_MODAL_TYPE.NEW)

  onNewProductModalOk = (formValues = {}) => {
    const {
      groupBySpecTableRows,
      sortedTableRows,
      isTwoLayerAttr,
      visibleRows,
      specSortList
    } = this.state
    const {
      models = [],
      isUpdateMode
    } = formValues
    // 以 index 決定是哪個商品被更新，避免使用 id 可能因為屬性名稱變更在更新時有所不同
    const targetProductMapByIndex = _.keyBy(models, PRODUCT_KEY.INDEX)
    const tableRows = isUpdateMode
      // 更新的話只更新指定商品
      ? _.flow(
        () => _.reduce(sortedTableRows, (collect, tableRow) => {
          const updatedTableRow = _.get(targetProductMapByIndex, tableRow[PRODUCT_KEY.INDEX])
          const isUpdatedRow = !_.isEmpty(updatedTableRow)
          if (isUpdatedRow) {
            // 修改商品列會重新調整資料
            collect[1].push(this.convertNewProductToTableRow(updatedTableRow))
          } else {
            collect[0].push(tableRow)
          }
          return collect
        }, [[], []]),
        // [[既有商品列集合]、[修改商品列集合]] > [...既有商品列, ...修改商品列]
        collect => _.concat(...collect)
      )()
      // 新增的話調整
      : _.map(models, this.convertNewProductToTableRow)
    const defaultTableInfo = {
      specSortList,
      ...(!isUpdateMode && ({ groupedRows: groupBySpecTableRows }))
    }
    // 重新分群、排序整個商品列(modelTable)
    const {
      sortedTableRows: newSortedTableRows,
      specSortList: newSpecSortList,
      groupedRowsWithIndex
    } = getConvertedTableInfo(defaultTableInfo, tableRows, isTwoLayerAttr)
    const currentRowSize = _.size(visibleRows) + _.size(tableRows)
    const newVisibleRows = _.slice(newSortedTableRows, 0, currentRowSize)
    this.updateReduxFormRows(newVisibleRows, true)
    const updatedListingModels = convertGroupedRowsToModels(
      newSpecSortList,
      groupedRowsWithIndex,
      isTwoLayerAttr
    )
    this.setState(
      () => ({
        sortedTableRows: newSortedTableRows,
        groupBySpecTableRows: groupedRowsWithIndex,
        specSortList: newSpecSortList,
        visibleRows: newVisibleRows
      }),
      () => this.getOverLimitError()
    )
    this.props.change('convertedModels', updatedListingModels)
    this.onNewProductModalCancel()
  }

  convertNewProductToTableRow = product => {
    const {
      form: {
        initiallyFetchedListing = {}
      } = {}
    } = this.props
    const { isTwoLayerAttr } = this.state
    const attrMap = getAttrMap(isTwoLayerAttr)
    const specSelectedValue = product[PRODUCT_KEY.SPEC_SELECTED_VALUE]
    const itemSpecSelectedValue = product[PRODUCT_KEY.ITEM_SPEC_SELECTED_VALUE]
    const images = product[PRODUCT_KEY.NEW_PRODUCT_IMAGES]
    const attributes = _.flow(
      () => [PRODUCT_KEY.ATTR, PRODUCT_KEY.ITEM_ATTR].map(key => product[key]),
      attrs => _.filter(attrs, attr => !_.isUndefined(attr)),
      filteredAttrs => _.map(filteredAttrs, (attr, index) => {
        const currentAttrMap = getAttrMap(index === 1)
        return { name: product[currentAttrMap.productName], values: attr }
      })
    )()
    const tableRow = {
      ...product,
      ...(!_.isEmpty(attributes) && {
        [PRODUCT_KEY.ATTRIBUTES]: attributes
      }),
      // 用於判斷是否為新增的商品,
      isNewProduct: true,
      // 用於顯示賣場圖
      image: _.get(images, '0.url', ''),
      // 新增商品的商品圖
      [PRODUCT_KEY.IMAGES]: images,
      // 新增的商品組出商品名稱
      [attrMap.productName]: `${initiallyFetchedListing.name}-${specSelectedValue}${isTwoLayerAttr ? `-${itemSpecSelectedValue}` : ''}`
    }
    return tableRow
  }

  updateReduxFormRows = (newVisibleRows, withDefaultState) => {
    const { form, dispatch } = this.props
    const { isTwoLayerAttr } = this.state
    const attrMap = getAttrMap(isTwoLayerAttr)
    const reduxFormFields = isTwoLayerAttr
      ? [
        TABLE_COLUMN.SPEC_SELECTED_VALUE,
        TABLE_COLUMN.ITEM_SPEC_SELECTED_VALUE
      ]
      : [TABLE_COLUMN.SPEC_SELECTED_VALUE]
    // 手動清除不存在的屬性，因為 redux form unregister field 不會清除已寫入資料
    const currentFormState = withDefaultState
      ? _.cloneDeep(
        _.get(form, TABLE_FORM_SECTION_NAME, {})
      )
      : {}
    const newTableForm = _.reduce(newVisibleRows, (form, row) => {
      const {
        index,
        [attrMap.productId]: id,
        [attrMap.productName]: productName,
        [attrMap.attributes]: attributes
      } = row
      const specValues = isTwoLayerAttr
        ? [
          [_.get(row, PRODUCT_KEY.SPEC_SELECTED_VALUE)],
          _.get(row, PRODUCT_KEY.ITEM_SPEC_SELECTED_VALUE)
        ]
        : [_.get(row, attrMap.specSelectedValue)]
      for (const [specIndex, specField] of reduxFormFields.entries()) {
        _.set(form, `${id}_${specField}_${index}`, specValues[specIndex])
      }
      _.set(form, `${id}_${TABLE_COLUMN.NAME}_${index}`, productName)
      _.set(form, `${id}_${TABLE_COLUMN.ATTRIBUTES}_${index}`, attributes)
      return form
    }, currentFormState)
    // 將整個表格內表單去除勾選欄位與已刪除商品屬性再一次寫入
    dispatch(
      actions.change(UPDATE_LISTING_FORM_KEY, TABLE_FORM_SECTION_NAME, newTableForm)
    )
  }

  setSortedTableRow = (sortedData) => {
    const {
      isTwoLayerAttr,
      sortedTableRows: prevSortedTableRows
    } = this.state
    const tableRows = [
      ...sortedData,
      ..._.slice(prevSortedTableRows, _.size(sortedData), _.size(prevSortedTableRows))
    ]
    // 避免排序中有 key 是純數字在計算時會自動往前排，所以直接用排序好的資料找出目前的排序
    const specSortList = getSpecSortListFromRows(tableRows)
    const {
      sortedTableRows,
      specSortList: newSpecSortList,
      groupedRowsWithIndex
    } = getConvertedTableInfo({ specSortList }, tableRows, isTwoLayerAttr)
    const newVisibleRows = _.slice(sortedTableRows, 0, _.size(sortedData))
    // 交換順序後表格列對應的商品 index 會變更所以要重洗一次
    this.updateReduxFormRows(newVisibleRows, false)
    this.setState({
      sortedTableRows,
      groupBySpecTableRows: groupedRowsWithIndex,
      specSortList: newSpecSortList,
      visibleRows: newVisibleRows
    })
  }

  checkToStoreAction = sortTableProps => {
    const { oldIndex, newIndex } = sortTableProps
    const isChangeFirstRow = (
      (oldIndex !== newIndex) &&
      (oldIndex === 0 || newIndex === 0)
    )
    if (isChangeFirstRow) {
      const {
        executeConfirmAction,
        executeCancelAction
      } = this.getSortableTableRef(this.modelTable)
      this.executeOrWaitForConfirm(
        () => true,
        () => executeConfirmAction && executeConfirmAction(),
        () => executeCancelAction && executeCancelAction()
      )
    }
    return isChangeFirstRow
  }

  executeOrWaitForConfirm = (checkIsFirstRow, confirmCallback, cancelCallback) => {
    if (!checkIsFirstRow()) {
      confirmCallback()
      return
    }
    this.afterModalConfirm = confirmCallback
    this.afterModalCancel = cancelCallback
    this.setState({ sortConfirmModalVisible: true })
  }

  onSortConfirmModalOk = () => {
    this.afterModalConfirm && this.afterModalConfirm()
    this.onSortConfirmModalClose()
  }

  onSortConfirmModalCancel = () => {
    this.afterModalCancel && this.afterModalCancel()
    this.onSortConfirmModalClose()
  }

  onSortConfirmModalClose = () => {
    this.afterModalConfirm = null
    this.afterModalCancel = null
    this.setState({ sortConfirmModalVisible: false })
  }

  showErrorIfProductsOverLimit = async (errorMsg, scrollToError = true) => {
    const isOverLimit = !_.isEmpty(errorMsg)
    if (isOverLimit && scrollToError) {
      const targetRow = document.querySelector(`#${TABLE_TIP_KEY}`)
      scrollElementToCenter(targetRow)
    }
  }

  beforeLeavePage = () => {
    // updateListingForm 預設 okta redirect 前會儲存 redux form 到 storage
    // 所以在離開頁面前如果 storage 有資料代表即將要 okta redirect
    const isRefreshOkta = !_.isEmpty(loadLocal(UPDATE_LISTING_FORM_KEY))
    if (isRefreshOkta) {
      saveIntoLocal(UPDATE_LISTING_MODEL_STATE_KEY, this.state)
    }
  }

  afterFormLoaded = async () => {
    const {
      updateListingModelProposal: {
        models: modelsFromProposal = []
      } = {},
      form: {
        listing: proposalFormListing = {},
        models = []
      } = {},
      readOnly
    } = this.props
    let listing
    if (readOnly) {
      // 已經送出的提案不需要再確認賣場規格不一致
      listing = { models: modelsFromProposal, productStructuredDataList: [] }
    } else {
      const productStructuredDataList = _.get(proposalFormListing, 'productStructuredDataList', [])
      const skuDetail = _.get(proposalFormListing, 'skuDetail', {})
      listing = { models, productStructuredDataList, skuDetail }
    }
    // 無屬性賣場、規格不一致賣場跳出阻擋視窗
    const validation = getUpdateListingModelValidateResult(listing)

    this.setState({ proposalFormListing })
    await delay(0)
    if (!validation.isValid) {
      this.setState({
        // 賣場驗證不通過直接跳出視窗阻止修改
        invalidListingModalVisible: true,
        invalidListingValidation: validation
      })
      return
    }

    // 取得新增商品時規格選單選項
    await this.loadNewProductSpecOptions()
    const { isDataLoadFromStorage } = this.state
    // 如果從 storage 把狀態都寫入就不需要再從 prop 取得預設的資料來產生表格
    if (!isDataLoadFromStorage) {
      // 待 listing 回傳後才更新表格預設屬性商品
      await this.setListingModels()
    }
  }

  beforeFormSubmit = async () => {
    const {
      actions,
      form,
      initialForm,
      targetListingId
    } = this.props
    const { isLayerAttrChanged, isNoLayerAttr } = this.state
    this.props.setIsLoading(true)
    const [changeStatus, message] = (isLayerAttrChanged || isNoLayerAttr)
      ? []
      : await checkIsListingChanged(actions, initialForm, targetListingId)
    switch (changeStatus) {
    // 賣場的商品屬性與進入時不一致
      case LISTING_CHANGE_STATUS.DIFF: {
        this.setState({ listingChangedModalVisible: true })
        this.props.setIsLoading(false)
        return false
      }
      // 檢查失敗
      case LISTING_CHANGE_STATUS.FAIL: {
        Toast.error(message)
        this.props.setIsLoading(false)
        return false
      }
      case LISTING_CHANGE_STATUS.SAME:
      default: {
        break
      }
    }

    const {
      specSortList,
      groupBySpecTableRows,
      isTwoLayerAttr
    } = this.state
    const updatedListingModels = convertGroupedRowsToModels(
      specSortList,
      groupBySpecTableRows,
      isTwoLayerAttr
    )
    // 送出完成提案前更新調整完的屬性商品
    this.props.change('convertedModels', updatedListingModels)
    const initFormWithModelTableForm = {
      ...initialForm,
      [TABLE_FORM_SECTION_NAME]: _.get(form, TABLE_FORM_SECTION_NAME)
    }
    this.props.change('initiallyFetchedListing', initFormWithModelTableForm)
    return true
  }

  afterComplete = async () => {
    const { sortedTableRows } = this.state
    this.props.setIsLoading(false)
    this.setState({ isAllowedLoadmore: false })
    // 送出後取得新增與刪除原有的商品屬性重新計算成表格列
    this.updateModifiedTableRows()
    // 提案完成提案後會以請求回應蓋掉原先表單資料，所以需要把表格內資料重新寫回去
    const importRows = _.filter(sortedTableRows, row => row.isNew)
    await delay(0)
    this.updateModalTableForm(importRows)
  }

  updateModifiedTableRows = () => {
    const { updateListingModelProposal } = this.props
    const modifiedTableRows = getModifiedTableRows(updateListingModelProposal, this.state)
    if (_.isEmpty(modifiedTableRows)) {
      return
    }

    const { tableRows, removedTableRows } = modifiedTableRows
    this.setSortedTableRow(_.slice(tableRows, 0, ROW_SIZE))
    this.setState({ removedTableRows, sortedTableRows: tableRows })
  }

  loadmore = async () => {
    const {
      visibleRows,
      sortedTableRows,
      isAllowedLoadmore
    } = this.state
    if (!isAllowedLoadmore) {
      return
    }

    const nextVisibleRows = _.slice(sortedTableRows, 0, _.size(visibleRows) + ROW_SIZE)
    // 載入更多後會增加新的表格列，因此需要更新一次表格列
    this.updateReduxFormRows(nextVisibleRows, true)
    const { setSortableAreaStyles } = _.get(this.modelTable, 'current.sortableTable.current', {})
    await delay(500)
    this.setState(
      () => ({ visibleRows: nextVisibleRows }),
      async () => {
        // 等待新的表格列載入後重新計算可拖曳範圍
        await delay(0)
        setSortableAreaStyles && setSortableAreaStyles()
      }
    )
  }

  allowLoadmore = () => {
    this.setState(
      () => ({ isAllowedLoadmore: true }),
      () => this.loadmore()
    )
  }

  toggleBatchRemoveMode = (isBatchRemoveMode) => {
    const nextState = _.isUndefined(isBatchRemoveMode)
      ? !this.state.isBatchRemoveMode
      : isBatchRemoveMode
    this.setState({ isBatchRemoveMode: nextState })
    // 進入移除模式時提案送出按鈕 disabled
    this.props.toggleDisableSubmitBtn(nextState)
  }

  onBatchRemove = productIdList => {
    const { sortedTableRows, isTwoLayerAttr } = this.state
    const attrMap = getAttrMap(isTwoLayerAttr)
    const productIdMap = _.keyBy(productIdList)
    const batchRemoveRows = _.filter(sortedTableRows, row => {
      const productId = _.get(row, attrMap.productId)
      const targetId = `${productId}_${row.index}`
      return (
        // 從表單勾選批次移除(會有 row index 準確刪除指定一個表格列)
        (targetId in productIdMap) ||
        // 從自行輸入編號批次移除(只有 productId 所以遇到重複 sku 時會刪除多筆表格列)
        (productId in productIdMap)
      )
    })
    this.onProductModalOpen(batchRemoveRows, PRODUCT_MODAL_TYPE.DELETE)
  }

  onAttrSelectorChange = optionOrString => {
    // 來源有選單選項或手動輸入不同格式
    const selectedValue = _.isString(optionOrString)
      ? optionOrString
      : _.get(optionOrString, 'value')
    this.setState({ attrSelectorValue: [selectedValue] })
    const originListing = _.get(this.props, 'form', {})
    const modifiedListing = {
      ...originListing,
      // 轉成有屬性後為了確保表格列可以顯示屬性名稱預設會塞一筆假的商品列
      // LAYER_CHANGED_DEFAULT_SKU 的商品在產生預設商品列時(setListingModels)會濾掉
      models: [{
        sku: LAYER_CHANGED_DEFAULT_SKU,
        spec: { name: selectedValue }
      }]
    }
    this.setListingModels(modifiedListing)
  }

  checkIsNoLayerListingBefore = () => {
    const { form } = this.props
    const isNoLayerListingBefore = _.get(form, 'listing.origLayer') === 0
    return isNoLayerListingBefore
  }

  render () {
    const {
      readOnly,
      targetListingId,
      form,
      updateListingModelProposal,
      complimentaryFeatureToggle,
      change,
      shortTitleFeatureToggle,
      attrsFeatureToggle
    } = this.props
    const {
      proposalFormListing,
      isNoLayerAttr,
      isLayerAttrChanged,
      isTwoLayerAttr,
      isAllowedLoadmore,
      isDuplicatedProductExist,
      isExpress24Hr,
      invalidListingValidation,
      isProductsLoading,
      sortedTableRows,
      removedTableRows,
      groupBySpecTableRows,
      visibleRows,
      addedTableRowMap,
      specSortList,
      targetProducts,
      importRuleModalVisible,
      specSortModalVisible,
      deleteProductModalVisible,
      visibleProductModalVisible,
      newProductModalVisible,
      sortConfirmModalVisible,
      invalidListingModalVisible,
      listingChangedModalVisible,
      batchRemoveModalVisible,
      isBatchRemoveMode,
      specDetailMapBySpec,
      attributesOptionsMapByName,
      attrSelectorOptions,
      attrSelectorValue
    } = this.state
    const editable = !readOnly
    const isNoLayerListingBefore = (readOnly && this.checkIsNoLayerListingBefore())
    const isExtraModelVisible = (
      getIsProposalShowExtraModals(_.get(updateListingModelProposal, 'createdTs')) &&
      complimentaryFeatureToggle
    )
    const [totalRowsSize, visibleRowsSize] = _.map([sortedTableRows, visibleRows], _.size)
    const isNeedInfiniteScroll = totalRowsSize > ROW_SIZE
    const isMoreRowsExist = isNeedInfiniteScroll
      ? visibleRowsSize < (isAllowedLoadmore ? totalRowsSize : ROW_SIZE)
      : false
    return (
      <>
        {
          // 無屬性賣場、被調整過的有屬性賣場可以設定賣場屬性
          // 原本是無屬性賣場改成有屬性在檢視頁顯示設定賣場屬性選單
          (isNoLayerAttr || isLayerAttrChanged || isNoLayerListingBefore) && (
            <>
              <h4>
                設定賣場屬性
                <Tip
                  type='info'
                  tag='span'
                >
                  {' (您可將無選項賣場調整為單層選項賣場)'}
                </Tip>
              </h4>
              <div className={styles.attrSelector}>
                <MenuSelect
                  placeholder='選擇或輸入屬性(ex.)顏色'
                  options={attrSelectorOptions}
                  value={attrSelectorValue}
                  onSelect={this.onAttrSelectorChange}
                  onCustomInputSubmit={this.onAttrSelectorChange}
                  customInputButtonText='自訂屬性'
                  closeOnSelect
                  closeOnCustomInputSubmit
                  editableCustomInput
                  enableCustomInput
                  disabled={readOnly}
                />
              </div>
            </>
          )
        }
        {
          editable && (
            <>
              <h4>匯入商品資料</h4>
              <ProposalBlock className={styles.block}>
                <p className={styles.condition}>
                  匯入的商品需符合條件，請參考
                  <HyperLink onClick={this.onImportRuleModalOpen}>
                    條件規定
                  </HyperLink>
                </p>
                {
                // 匯入表單是 fixed position 需要等賣場資訊取得後再計算位置，
                // 否則會因為提案編號或賣場編號等資訊造成位置偏移
                  (isLayerAttrChanged || !_.isEmpty(specSortList)) && (
                    <ImportForm
                      onSubmit={this.onImportProducts}
                      isNoLayerAttr={isNoLayerAttr}
                      isTwoLayerAttr={isTwoLayerAttr}
                      isLayerAttrChanged={isLayerAttrChanged}
                      dataMap={groupBySpecTableRows}
                      sortList={specSortList}
                      openNewProductModal={this.onNewProductModalOpen}
                      listing={proposalFormListing}
                    />
                  )}
                <ImportRuleModal
                  className={styles.importRuleModal}
                  visible={importRuleModalVisible}
                  onCancel={this.onImportRuleModalCancel}
                  width={445}
                />
              </ProposalBlock>
            </>
          )}
        <h4>賣場資訊</h4>
        <ProposalBlock
          className={styles.listingBlock}
          data-role='listing-info'
        >
          <ListingInfo
            listing={proposalFormListing}
            tableRows={sortedTableRows}
          />
        </ProposalBlock>
        {/* attribute-table 是確認頁的 `查看商品編號` 用來指定移動到商品編號的 selector */}
        <h4 data-role='attribute-table'>屬性項目調整</h4>
        <FormLoader isLoading={isProductsLoading}>
          <ProposalBlock
            className={cx(styles.listingBlock, styles.tableBlock)}
            data-role='add-attr-table'
          >
            {
              (!isBatchRemoveMode && editable) && (
                <EditModeTableTip
                  id={TABLE_TIP_KEY}
                  className={styles.tableTip}
                  isTwoLayerAttr={isTwoLayerAttr}
                  isDuplicatedProductExist={isDuplicatedProductExist}
                  form={form}
                  getOverLimitError={this.getOverLimitError}
                />
              )
            }
            {
              (editable && !isNoLayerAttr) && (
                <RemoveModeTableTip
                  id={REMOVE_MODE_TABLE_TIP_KEY}
                  className={cx(
                    styles.tableTip,
                    { [styles.batchRemoveMode]: isBatchRemoveMode }
                  )}
                  tableRows={sortedTableRows}
                  groupBySpecTableRows={groupBySpecTableRows}
                  batchRemoveMode={isBatchRemoveMode}
                  toggleBatchRemoveMode={this.toggleBatchRemoveMode}
                  onBatchRemove={this.onBatchRemove}
                  onBatchRemoveModalOpen={this.onBatchRemoveModalOpen}
                />
              )
            }
            <InfiniteScroll
              dataLength={visibleRowsSize}
              next={this.loadmore}
              hasMore={isMoreRowsExist}
              loader={<LoadingSpinner size={SIZE.MEDIUM} />}
              className={styles.infiniteScroll}
              style={{ overflow: 'hidden' }}
              scrollThreshold={0.9}
            >
              <ModelTable
                ref={this.modelTable}
                columnsProps={this.columnsProps}
                listing={proposalFormListing}
                form={form}
                sortList={specSortList}
                tableRows={visibleRows}
                addedRowMap={addedTableRowMap}
                dataMap={groupBySpecTableRows}
                attributesOptionsMapByName={attributesOptionsMapByName}
                isNoLayerAttr={isNoLayerAttr}
                isTwoLayerAttr={isTwoLayerAttr}
                isExpress24Hr={isExpress24Hr}
                onSortEnd={this.setSortedTableRow}
                onAttrChange={this.onAttrChange}
                checkToStoreAction={this.checkToStoreAction}
                openNewProductModal={this.onNewProductModalOpen}
                batchRemoveMode={isBatchRemoveMode}
                attrsFeatureToggle={attrsFeatureToggle}
                readOnly={readOnly}
                withActions
                draggable
              />
            </InfiniteScroll>
            {
              (isNeedInfiniteScroll && !isAllowedLoadmore) && (
                <div className={styles.allowLoadmoreBtnArea}>
                  <Button
                    onClick={this.allowLoadmore}
                    size='large'
                    buttonType='outline'
                    fluid
                  >
                    載入更多
                  </Button>
                </div>
              )}
          </ProposalBlock>
        </FormLoader>
        {
          isExtraModelVisible && EXTRA_MODEL_TABLE_TYPES.map(tableType => {
            const title = EXTRA_MODEL_TITLE[tableType]
            const TableComponent = EXTRA_MODEL_TABLE[tableType]
            return (
              <Fragment key={tableType}>
                <h4 data-role={`${tableType}-table-area`}>
                  {`${title}項目調整`}
                </h4>
                <ProposalBlock
                  className={cx(styles.listingBlock, styles.tableBlock)}
                  data-role={`add-${tableType}-table`}
                >
                  <TableComponent
                    shortTitleFeatureToggle={shortTitleFeatureToggle}
                    actions={this.props.actions}
                    change={change}
                    readOnly={readOnly}
                    title={title}
                  />
                </ProposalBlock>
              </Fragment>
            )
          })
        }
        {
          (readOnly && !_.isEmpty(removedTableRows)) && (
            <>
              <h4 className={styles.removedTitle}>移除之屬性商品</h4>
              <ProposalBlock
                className={styles.listingBlock}
                data-role='remove-attr-table'
              >
                <ModelTable
                  form={form}
                  tableRows={removedTableRows}
                  isTwoLayerAttr={isTwoLayerAttr}
                  columnsProps={this.columnsProps}
                  draggable={false}
                  attrsFeatureToggle={attrsFeatureToggle}
                  readOnly
                />
              </ProposalBlock>
            </>
          )
        }
        {
          // 贈品、加價購移除表格
          (isExtraModelVisible && readOnly) && EXTRA_MODEL_TABLE_TYPES.map(tableType => {
            const removedData = _.get(form, `${PAYLOAD_DIFF_TYPE[tableType]}.removed`, [])
            if (_.isEmpty(removedData)) {
              return null
            }

            const title = EXTRA_MODEL_TITLE[tableType]
            return (
              <Fragment key={tableType}>
                <h4
                  data-role={`${tableType}-table-area`}
                  className={styles.removedTitle}
                >
                  {`移除${title}項目調整`}
                </h4>
                <ProposalBlock
                  className={cx(styles.listingBlock, styles.tableBlock)}
                  data-role={`removed-${tableType}-table`}
                >
                  <ExtraModelReadOnlyTable
                    shortTitleFeatureToggle={shortTitleFeatureToggle}
                    tableType={tableType}
                  />
                </ProposalBlock>
              </Fragment>
            )
          })
        }
        <SpecSortModal
          ref={this.specSortModal}
          visible={specSortModalVisible}
          isTwoLayerAttr={isTwoLayerAttr}
          columnsProps={this.columnsProps}
          onOk={this.onSpecSortModalOk}
          onCancel={this.onSpecSortModalCancel}
          dataMap={groupBySpecTableRows}
          sortList={specSortList}
          attributesOptionsMapByName={attributesOptionsMapByName}
          attrsFeatureToggle={attrsFeatureToggle}
          width={550}
          zIndex={10}
          readOnly={readOnly}
        />
        <BatchRemoveModal
          ref={this.batchRemoveModal}
          visible={batchRemoveModalVisible}
          isTwoLayerAttr={isTwoLayerAttr}
          tableRows={sortedTableRows}
          width={550}
          onCancel={this.onBatchRemoveModalCancel}
          onBatchRemove={this.onBatchRemove}
          zIndex={10}
        />
        <DeleteProductModal
          visible={deleteProductModalVisible}
          isTwoLayerAttr={isTwoLayerAttr}
          products={targetProducts}
          onOk={this.onDeleteProductModalOk}
          onCancel={this.onDeleteProductModalCancel}
          width={445}
          zIndex={20}
        />
        <VisibleProductModal
          visible={visibleProductModalVisible}
          isTwoLayerAttr={isTwoLayerAttr}
          products={targetProducts}
          onOk={this.onVisibleProductModalOk}
          onCancel={this.onVisibleProductModalCancel}
          width={445}
          zIndex={20}
        />
        <UiStateContainer>
          <NewProductModal
            visible={newProductModalVisible}
            specDetailMapBySpec={specDetailMapBySpec}
            dataMap={groupBySpecTableRows}
            sortList={specSortList}
            products={targetProducts}
            onOk={this.onNewProductModalOk}
            onCancel={this.onNewProductModalCancel}
            // 有用到 redux-form 不能帶 form props
            // 因為 initial form 時 redux form 取 form name 的 key 就是 form
            // 如果帶了 form 會造成 set form name 變成預期外的值而非 form config 的值
            updateListingModelForm={form}
            readOnly={readOnly}
            width='90%'
            zIndex={20}
          />
        </UiStateContainer>
        <SortConfirmModal
          visible={sortConfirmModalVisible}
          onOk={this.onSortConfirmModalOk}
          onCancel={this.onSortConfirmModalCancel}
          width={445}
          zIndex={20}
        />
        <InvalidListingModal
          visible={invalidListingModalVisible}
          listing={proposalFormListing}
          validation={invalidListingValidation}
          width={445}
        />
        <ListingChangedModal
          visible={listingChangedModalVisible}
          id={targetListingId}
          width={445}
        />
      </>
    )
  }
}

const selector = formValueSelector(UPDATE_LISTING_FORM_KEY)
const FORM_FIELDS = [
  'models',
  'listing',
  'applicant',
  'initiallyFetchedListing',
  'catItemId',
  TABLE_FORM_SECTION_NAME,
  ...EXTRA_MODEL_TABLE_TYPES.map(tableType => PAYLOAD_DIFF_TYPE[tableType])
]
// 抽出提案指定欄位寫入 props
const ListingModelWithReduxForm = connect(state => {
  const location = _.get(state, 'router.location', {})
  const {
    id,
    listingId
  } = HistoryUtil.retrieveQueryParams({ location })
  const form = selector(state, ...FORM_FIELDS)
  const isExtraModelEmpty = _.flow(
    () => _.get(form, EXTRA_MODEL_FORM_SECTION, {}),
    listing => _.map(EXTRA_MODEL_TABLE_TYPES, type => _.get(listing, type, [])),
    extraModels => _.concat(...extraModels),
    _.isEmpty
  )()
  return {
    form,
    initialForm: selector(state, 'initiallyFetchedListing'),
    // 從賣場查詢進入會帶 listingId, overview & compose 帶 id
    targetListingId: listingId || id,
    // 完成提案時、送出提案時表單會有新建出來的提案資料
    updateListingModelProposal: _.get(state, `form.${UPDATE_LISTING_FORM_KEY}.values`),
    isExtraModelEmpty,
    complimentaryFeatureToggle: getFeatureToggle(state.flags, 'uListing2'),
    shortTitleFeatureToggle: getFeatureToggle(state.flags, 'sp_shortTitle'),
    attrsFeatureToggle: getFeatureToggle(state.flags, 'sp_attOPT')
  }
})(ListingModel)

export default ListingModelWithReduxForm
